import { h } from 'preact'
import { tagParser } from '../../js/modules/utilities.js'

export const BanniereHTML = (props) => {
   let { debug, tag, date, title, description, legals, images, URL, textColor, analytics, cacheKey } = props
   let deviceType = window.dataStoreHP.device
   let context = window.dataStoreHP.pageId
   title = tagParser(title)
   description = tagParser(description)
   
   legals = tagParser(legals)
   images = addProxymediaParams(images, deviceType, context)
   let adviseTags = {}
   if (analytics.pdbSc === 'adv') {
      adviseTags = {
         'data-pdb-ta': analytics.pdbTa,
         'data-adv-canal': analytics.advCanal,
         'data-adv-cappingdata': analytics.advCappingdata,
      }
   }

   return (
      <a
         href={URL}
         class={`BanniereHTML textcolor-${textColor}  banner-${context} ${debug ? 'debug' : ''}`}
         data-testid="banner"
         data-pdb-zid={analytics.pdbZid}
         data-pdb-sc={analytics.pdbSc}
         data-pdb-idc={analytics.pdbIdc}
         data-pdb-vi={images.img1}
         {...adviseTags}
         data-oevent-category={analytics.oeventCategory}
         data-oevent-action={analytics.oeventAction}
         data-oevent-label={analytics.oeventLabel}
         data-oevent-other={analytics.oeventOther}
         data-cache-key={cacheKey}
      >
         {deviceType === 'mobile' ? <PictureMobile {...images} /> : <PictureDesktop {...images} />}
         <div class="wrapper">
            <div class="content">
               {tag === '' && date === '' ? (
                  ''
               ) : (
                  <div class="top">
                     {tag !== '' ? <span class="ob1-tag ob1-tag-primary">{tag}</span> : ''}
                     {date !== '' ? <span class="date">{date}</span> : ''}
                  </div>
               )}
               <h3 class="title" dangerouslySetInnerHTML={{ __html: title }}></h3>
               <p class="description" dangerouslySetInnerHTML={{ __html: description }}></p>
               <div class="bottom">
                  <p class="legals" dangerouslySetInnerHTML={{ __html: legals }}></p>
               </div>
            </div>
         </div>
      </a>
   )
}

function PictureDesktop(images) {
   return (
      <picture>
         <source srcset={images.img3} media="(max-width: 959px)" />
         <source srcset={images.img1} media="(max-width: 1199px)" />
         <img class="background-img" src={images.img2} alt="" />
      </picture>
   )
}

function PictureMobile(images) {
   return (
      <picture>
         <source srcset={images.img1} media="(max-width: 479px)" />
         <source srcset={images.img2} media="(max-width: 599px)" />
         <source srcset={images.img3} media="(max-width: 719px)" />
         <img src={images.img4} alt="" class="background-img" />
      </picture>
   )
}

function addProxymediaParams(imagesData, deviceType, context) {
   let images, paramImg1, paramImg2, paramImg3, paramImg4
   deviceType = deviceType === 'mobile' ? 'mobile' : 'desktop'
   context = `${context}-${deviceType}`
   switch (context) {
      case '960x250':
      case 'hp-regulier-desktop':
         paramImg1 = 'format=960x250'
         paramImg2 = 'crop=960,250,right,32'
         break
      case '480x400':
      case 'hp-regulier-mobile':
      case 'hp-prospect-mobile':
      case 'hp-occasionnel-mobile':
      case 'vitrine-boutique-mobile':
         paramImg1 = 'format=480x400'
         paramImg2 = 'format=600x240'
         paramImg3 = 'format=720x288'
         paramImg4 = 'format=900x360'
         break
      case '960x380':
      case 'hp-prospect-desktop':
         paramImg1 = 'format=960x380'
         paramImg2 = 'crop=960,380,0,center'
         break
      case '1500x380':
      case 'hp-occasionnel-desktop':
      case 'n1-forfaits-desktop':
      case 'n1-forfaits-prospect-desktop':
      case 'vitrine-boutique-desktop':
         paramImg1 = 'format=x304'
         paramImg2 = 'format=x380'
         break
      case '480x520':
      case 'n1-forfaits-mobile':
      case 'n1-forfaits-prospect-mobile':
      case 'n1-tv-mobile':
      case 'n1-tv-prospect-mobile':
         paramImg1 = 'format=480x520'
         paramImg2 = 'format=600x240'
         paramImg3 = 'format=720x288'
         paramImg4 = 'format=900x360'
         break
      case '960x310':
      case 'n1-tv-desktop':
      case 'n1-tv-prospect-desktop':
         paramImg1 = 'format=960x310'
         paramImg2 = 'crop=960,310,0,39'
         break
   }

   if (deviceType === 'mobile') {
      images = {
         img1: `${imagesData.img1}?${paramImg1}&saveas=webp`,
         img2: `${imagesData.img2}?${paramImg2}&saveas=webp`,
         img3: `${imagesData.img2}?${paramImg3}&saveas=webp`,
         img4: `${imagesData.img2}?${paramImg4}&saveas=webp`,
      }
   } else {
      images = {
         img1: `${imagesData.img1}?${paramImg1}&saveas=webp`,
         img2: `${imagesData.img1}?${paramImg2}&saveas=webp`,
         img3: `${imagesData.img2}?${paramImg3}&saveas=webp`,
      }
   }

   return images
}
